import { VenueTips } from '../components/VenueTips';
import { rowPath } from '@anjabom/core';
import { Link, useParams } from 'react-router-dom';
import { seatLayouts, venueBySlug } from '@anjabom/core';
import { Breadcrumb } from '../components/Breadcrumb';
import { ExternalLink } from '../components/ExternalLink';
import { SurfaceBanner } from '../components/SurfaceBanner';
import { readSurfaceState } from '../lib/surface-state';

export function VenuePage() {
  const { venueSlug, sectionCode } = useParams();
  const venue = venueBySlug(venueSlug ?? '');
  const surface = readSurfaceState();
  if (!venue) {
    return (
      <section className="page narrow stack-lg">
        <SurfaceBanner state={surface === 'default' ? 'empty' : surface} empty="장소를 찾지 못했어요." />
        <h1>장소를 찾지 못했어요.</h1>
        <Link className="button button-primary" to="/start">장소 다시 찾기</Link>
      </section>
    );
  }
  const layouts = seatLayouts.filter((layout) => layout.venueId === venue.id);
  const sections = [...new Map(layouts.flatMap((layout) => layout.floors.flatMap((floor) => floor.sections.map((section) => [section.label, { layout, floor, section }] as const)))).values()];
  const selected = sectionCode ? sections.find((item) => item.section.id === sectionCode || item.section.id === sectionCode) : null;
  return (
    <section className="page narrow stack-lg">
      <Breadcrumb items={[{ label: '홈', href: '/' }, { label: venue.name, href: `/venue/${venue.slug}` }, ...(sectionCode ? [{ label: sectionCode }] : [])]} />
      <SurfaceBanner state={surface} empty="등록된 구역이 없어요." />
      <div>
        <p className="eyebrow">{venue.categoryId === 'cinema' ? '영화관' : '공연장'}</p>
        <h1>{selected ? `${venue.name} ${selected.section.label}` : venue.name}</h1>
        <p className="lede">{venue.region} · {venue.addressHint}{selected ? ` · ${selected.layout.title}` : ''}</p>
      </div>
      <div className="notice"><span className="notice-mark">i</span><span>시설 배치 참고 {layouts.length}종이에요. 특정 공연·상영 회차의 배치 확인과 관람 후기는 아직 별도로 확인해야 해요.</span></div>
      {selected?.section.rows?.length ? (
        <div className="card">
          <h2>{selected.section.label} 열 목록</h2>
          <p className="muted">{selected.section.rows.length}개 열이 공식 좌표로 확인됐어요. 인증 리뷰가 없으면 각 좌석은 모름이에요.</p>
          <ul>{selected.section.rows.slice(0, 12).map((row) => <li key={row.label}>{row.label}열 {row.seats.length}석</li>)}</ul>
        </div>
      ) : null}
      <div className="venue-list">
        {venue.spaces.map((space) => {
          const layout = layouts.find((item) => item.spaceId === space.id);
          return (
            <div className="venue-card" key={space.id}>
              <span><span className="venue-name">{space.name}</span><br /><span className="venue-meta">{space.format ?? layout?.title ?? '배치 확인 중'}</span></span>
              <Link className="button button-ghost" to={`/start?venue=${encodeURIComponent(venue.id)}`}>좌석 고르기</Link>
            </div>
          );
        })}
      </div>
      {!sectionCode && sections.length ? (
        <div className="stack">
          <h2>확인된 구역</h2>
          <div className="inline">
            {sections.map((item) => (
              <Link className="button" key={`${item.layout.layoutVersionId}-${item.section.id}`} to={`/venue/${venue.slug}/${encodeURIComponent(item.section.id)}`}>{item.section.label}</Link>
            ))}
          </div>
        </div>
      ) : null}
      <VenueTips venueId={venue.id}/><section className="stack"><h2>열별 시야 확인하기</h2>{layouts.map((layout)=><details key={layout.layoutVersionId}><summary>{venue.spaces.find((space)=>space.id===layout.spaceId)?.name}</summary>{layout.floors.flatMap((floor)=>floor.sections.map((section)=><div className="stack" key={`${floor.id}:${section.id}`}><h3>{section.label}</h3><div className="inline">{section.rows?.map((row)=><Link className="button" key={row.label} to={rowPath(layout,venue.slug,section.id,row.label)??'#'}>{row.label}열</Link>)}</div></div>))}</details>)}</section><ExternalLink className="button" href={venue.officialUrl}>공식 장소 정보 열기</ExternalLink>
    </section>
  );
}
